'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgArrowNext(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M10.17 9.192H3.21c-.52 0-.949-.27-1.13-.744a1.175 1.175 0 011.085-1.6H10.147l-.09-.09-2.689-2.75c-.452-.473-.474-1.15-.068-1.623.43-.473 1.153-.518 1.605-.09.406.406.79.811 1.197 1.217 1.175 1.217 2.35 2.412 3.525 3.629.497.518.497 1.217 0 1.735-1.536 1.578-3.095 3.155-4.632 4.733-.203.203-.43.338-.723.383-.588.068-1.152-.315-1.265-.901-.068-.428.045-.79.338-1.082l2.69-2.75c.067 0 .09-.022.135-.067z", fill: "currentColor" }))));
}

module.exports = SvgArrowNext;
//# sourceMappingURL=ArrowNext.js.map
